<div class="min-h-screen flex items-center justify-center p-6" style="background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);">
  <div class="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-md p-10">
    <div class="text-center mb-6">
      <div class="flex justify-center mb-4 px-24">
        <img src="/Logo.png" alt="Logo" class="w-full h-auto object-contain">
      </div>
      <h1 class="text-3xl font-semibold text-gray-800 mb-2 m-0">Accept Invitation</h1>
      <p class="text-base text-gray-500 m-0">Create your password to activate your account</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4">
      <div class="flex flex-col gap-2">
        <label for="password" class="block text-sm font-medium text-gray-700">Password *</label>
        <p-password
          inputId="password"
          formControlName="password"
          placeholder="Create your password"
          [toggleMask]="true"
          styleClass="w-full"
          inputStyleClass="w-full"
          [class.ng-invalid]="passwordError">
        </p-password>
        @if (passwordError) {
          <div class="text-xs text-red-500 min-h-[16px]">{{ passwordError }}</div>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label for="confirmPassword" class="block text-sm font-medium text-gray-700">Confirm Password *</label>
        <p-password
          inputId="confirmPassword"
          formControlName="confirmPassword"
          placeholder="Confirm your password"
          [toggleMask]="true"
          styleClass="w-full"
          inputStyleClass="w-full"
          [class.ng-invalid]="confirmPasswordError">
        </p-password>
        @if (confirmPasswordError) {
          <div class="text-xs text-red-500 min-h-[16px]">{{ confirmPasswordError }}</div>
        }
      </div>

      <div class="flex flex-col gap-2">
        <label for="fullName" class="block text-sm font-medium text-gray-700">Full Name *</label>
        <input
          id="fullName"
          pInputText
          formControlName="fullName"
          placeholder="Enter your full name"
          class="w-full" />
          @if (fullNameError) {
            <div class="text-xs text-red-500 min-h-[16px]">{{ fullNameError }}</div>
          }
        </div>

        <div class="flex flex-col gap-2">
          <label for="position" class="block text-sm font-medium text-gray-700">Position</label>
          <input
            id="position"
            pInputText
            formControlName="position"
            placeholder="Enter your position"
            class="w-full" />
            <div class="min-h-[16px]"></div>
          </div>

          @if (errorMessage) {
            <div class="bg-red-50 text-red-600 p-3 rounded-lg text-sm border border-red-200">
              {{ errorMessage }}
            </div>
          }

          <div class="mt-2">
            <p-button
              type="submit"
              label="Accept Invitation"
              [disabled]="form.invalid"
              [loading]="isLoading"
              styleClass="w-full">
            </p-button>
          </div>
        </form>
      </div>
    </div>

